import '../styles/index.scss';
import { Loader } from "@googlemaps/js-api-loader";
import { extend, debounce, pick, pickBy, forEach, groupBy, filter, sortBy } from "lodash"; 
import NeosMarker from '../images/neos-pin-blue.png';
import NeosCluster from '../images/neos-pin-cluster.png';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
const loader = new Loader({
  apiKey: view_params.gmaps_api,
  version: "weekly"
});

loader.load().then(async () => {
	let aoi_config_defaults = {
		show_all: false,
		style: false,
		map_id: '',
		starting_zoom: 12,
		cluster: true,
		glyph_image: "http://mydevelopment.test/wp-content/uploads/2024/09/neos-pin-blue.png",
	}
	let aoi_config = (window.aoi_config) ? window.aoi_config: aoi_config_defaults; 

	let map = jQuery('#map');
	let the_results_panel = jQuery('#clinics-result');

	let data; //api data
	let data_url = map.data('endpoint');
	let maxZoom = 22;
	let minZoom = 4;
	let defaultCenter = { lat: 37.25734013301679, lng: -96.8461563800428 }; //US (adjusted) centerm, != chicago
	let markers_data = [], markers = []; //holds response data

	let focusedMarker = false;
	let map_info = false;

	const { Map } = await google.maps.importLibrary("maps");
	const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

	//setup gmap info window.
	let infowindow = new google.maps.InfoWindow({				   
    ariaLabel: "Areas of Interest"
  });

	const get_formatted_address_card = (clinic, card = "map") => {
  	let address_fields = ['street_number','street_name','city','state_short','post_code'];
		let address_array = [];
		address_fields.forEach((key) =>{
			if(clinic.address[key] != '' && clinic.address[key]) {
				address_array.push(clinic.address[key]);
			}
		});

	

  	let string_content = 	"<div id=\""+clinic.ID+card+"\" class=\"clinic-result\">"+
										"<div class=\"clinic-name\">"+clinic.short_title+"</div>"+
										"<div class=\"clinic-address\">"+address_array.join(', ')+"</div>";
		if(clinic.phone_no != "" && clinic.phone_no != null) {
			string_content = string_content+"<div class=\"clinic-phone\">"+clinic.phone_no+"</div>";
		}
		if(clinic.email != "" && clinic.email != null) {
			string_content = string_content+"<div class=\"clinic-email\">"+clinic.email+"</div>";
		}
		if(clinic.website != "" && clinic.website != null) {
			string_content = string_content+"<div class=\"clinic-web-logo\"><a target=\"_blank\" href=\""+clinic.website+"\" class=\"\">Website</a>";
		}
		
		/*if(clinic[aoi_config.category_slug] && clinic[aoi_config.category_slug].length) { 							
			if(clinic[aoi_config.category_slug][0] && clinic[aoi_config.category_slug][0].map_icon){
				string_content = string_content+"<img src=\""+clinic[aoi_config.category_slug][0].map_icon.url+"\"/>";	
			}
		}*/

		string_content = string_content+"</div></div>";	
		return string_content;
  }

  //let map_style_id =  (window.aoi_config && window.aoi_config.map_style_id) ? 
				

	const initialize_map = () => {
		let map_params =  {
			zoom: aoi_config.starting_zoom,
			maxZoom: maxZoom, 
			minZoom: minZoom,
			keyboardShortcuts: false,
			center: defaultCenter,
			mapId: aoi_config.map_id,
			disableDefaultUI: true,
		};

		map = new Map(document.getElementById("map"), map_params);
		map.setOptions({draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: true});
		jQuery('#gmap_loading').css('display', 'flex');


		const promise = new Promise((resolve, reject) => {
			google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
			 resolve({ state: 'initialized'});
			});

		});


		return promise;

		
		/*setTimeout(function() {

			get_data(defaultCenter, get_radius_from_map());
			
		},2000);*/
	}

	const get_data = (center = false, radius = 100, address = false) => {
		let data;
		let return_locations = true;
		let ispan = false;
		if(address) {
			data = {
				address: address,
				radius: radius
			};
		} else {
			ispan = true;
			data = {
				center: center,
				radius: radius
			};
		}

		if(return_locations) {
			data.get_data = return_locations;
			return_locations = false;
		}

		jQuery.ajax({
			type : "post",
			dataType : "json",
			url : "/wp-json"+data_url,
			data : data,
			success: (response) => {

				if(response.center) {
					map.setCenter(new google.maps.LatLng(response.center.lat,response.center.lng));
					map.setZoom(8);
				}

				if(response.data && response.data.length) {
					markers_data = response.data;
					if(jQuery(window).width() >= 782) {
						map.setOptions({draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: true});
					}

					//get the home objects
					if(map_info.state == 'initialized') {
						let home_data = pickBy(response.data, (i, k) => {
							if(!i[aoi_config.category_slug]) {
								return false;
							}
							if(i[aoi_config.category_slug].name == "home") {
								return true;	
							} else {
								return false;
							}
							
						});

						home_data = Object.values(home_data);
					
						if(home_data.length > 1) {
							var markers = [];//some array
							var bounds = new google.maps.LatLngBounds();
							for (var i = 0; i < home_data.length; i++) {
								var newLatLng = new google.maps.LatLng(home_data[i].address.lat, home_data[i].address.lng);
            		bounds.extend(newLatLng);
							}

							map.fitBounds(bounds);

						} else {
							home_data = Object.values(home_data)[0]; // returns 'someVal'
							if(home_data) {
								map.setCenter(new google.maps.LatLng(home_data.address.lat,home_data.address.lng));
								map.setZoom(aoi_config.starting_zoom);
								console.log('home_data;', home_data);
							}

						}
						
					}

					draw_markers();
					draw_sidebar();
					/*
					if(!is_initialized) {
						handle_center_bounds_changed();
						is_initialized = true;
					}	*/			}
				jQuery('#gmap_loading').hide();
				}
		});
	};




	//get initial Data
	//get_data();
	
	const draw_home_markers = (data) => {
		data.forEach((marker) => {
			if(!jQuery('#'+marker.clinic.ID+'sidebar').length) { 
				let cardData = jQuery(get_formatted_address_card(marker.clinic, "sidebar"));
			
				if(jQuery(window).width() > 766) { 
					cardData.on( "click", function() {
						markers.forEach((marker) => { 	
							if(jQuery(this).attr('id') == marker.clinic.ID+'sidebar') {
								google.maps.event.trigger(marker, 'click');
							}
						});

					} );
				}
				cardData.addClass('home');
				the_results_panel.append(cardData);
			}
		
		});
	}

	const draw_sidebar = () => {
		let the_map_bounds = map.getBounds();
		let ne = the_map_bounds.getNorthEast();
		let sw = the_map_bounds.getSouthWest();
		let nearby_clinics = [];
	
		markers.forEach((marker) => { 	
			let marker_position = new google.maps.LatLng(marker.clinic.address.lat, marker.clinic.address.lng);
			if(the_map_bounds.contains(marker_position) || aoi_config.show_all){
				nearby_clinics.push(marker);
			}
		});

		
		if(!aoi_config.show_all) {
			the_results_panel.empty();
			
		} else {
			jQuery('#initial-msg').remove();
		}

		if(nearby_clinics.length) {
			if(jQuery.trim(jQuery('#start_address').val()) == '' || aoi_config.show_all) {
				//do a group by state and output alpha state
				let groupByF = (k) => {
					return k.clinic.address.state;
				};
				if(aoi_config.aoi_map_group_by) {
					groupByF = aoi_config.aoi_map_group_by;
				}
				let groupedBy = groupBy(nearby_clinics, groupByF);

				groupedBy = pick(groupedBy, Object.keys(groupedBy).sort());
				
				if(groupedBy.home) {
					let homedata = groupedBy.home;
					delete groupedBy.home;
					draw_home_markers(homedata);
				}

				forEach(groupedBy, (aois, state) => {
					let group = jQuery("<div class=\"cat_group\">");
					if(aoi_config.style == 'accordion'){ 
						group.addClass('accordion-style');
					}
					if(!jQuery('#'+camelize(state)).length) {
						let header = jQuery('<label for="'+camelize(state)+'"class="result_header">'+state+'</label>');
						let accordion_check = jQuery('<input class="accordion_radio" type="radio" id="'+camelize(state)+'" name="accordion" value="'+camelize(state)+'">');

						header.on("click", (evt) => {
							let checkbox = header.find('.accordion_radio');
							if(checkbox.prop('checked')){
								checkbox.prop('checked', false);
							} else {
								checkbox.prop('checked', true);
							}
							evt.stopPropagation();
							evt.preventDefault();
						});

						if(aoi_config.style == 'accordion'){
							header.append(accordion_check);
						}
						
						group.append(header);
					}
					let aoi_group = jQuery("<div class=\"aoi_group\">");
					aois.forEach((marker) => {
						if(!jQuery('#'+marker.clinic.ID+'sidebar').length) { 
							let cardData = jQuery(get_formatted_address_card(marker.clinic, "sidebar"));
						
							if(jQuery(window).width() > 766) { 
								cardData.on( "click", function() {
									markers.forEach((marker) => { 	
										if(jQuery(this).attr('id') == marker.clinic.ID+'sidebar') {
											google.maps.event.trigger(marker, 'click');
										}
										

										// 
									});

								} );
							}
							aoi_group.append(cardData);
						}
					
					});
					group.append(aoi_group);
					the_results_panel.append(group);

				});
			} else {
				nearby_clinics.forEach((marker) => {
					let cardData = jQuery(get_formatted_address_card(marker.clinic, "sidebar"));
					if(jQuery(window).width() > 766) { 
						cardData.on( "click", function() {
							markers.forEach((marker) => { 	
								if(jQuery(this).attr('id') == marker.clinic.ID+'sidebar') {
									google.maps.event.trigger(marker, 'click');
								}
								// 
							});
						} );
					}
					the_results_panel.append(cardData);
				
				});

			}
			
		} else {
			if(jQuery('#start_address').length) { 
				if(jQuery('#start_address').val().length < 5)  {
					the_results_panel.append("<div class=\"no-results\">Search Your Location Above<span class=\"hide-text-on-mobile\"> or Interact with Map to find a Clinic</span>.</div>");
				} else {
					the_results_panel.append("<div class=\"no-results\">No results found, please check your address and try again.</div>");
				}
			}
			
		}
	}

	const draw_markers = () => {

		if(!markers.length) {
			markers_data.forEach((clinic) => {
				
				let location = {
			    lat: clinic.address.lat,
			    lng: clinic.address.lng
			  };
			 	;
			 	
			 	// A marker with a custom SVG glyph.
				const glyphImg = document.createElement("img");
				let pin_args = {
			  		scale: 1,
			      background: "transparent",
			      borderColor: "transparent"
				}

				if(aoi_config.scale) { 
					pin_args.scale = aoi_config.scale
				}




				let marker_args;
				let pinsize = 30;
				if(aoi_config.glyph_image || clinic.map_icon || clinic[aoi_config.category_slug].map_icon) {
					glyphImg.src = aoi_config.glyph_image;  //get from aoi_config in window

					if(clinic[aoi_config.category_slug].map_icon) {
						glyphImg.src = clinic[aoi_config.category_slug].map_icon.url;
					}

					if(clinic.map_icon) {
						glyphImg.src = clinic.map_icon;

					}


					glyphImg.style = "height:auto !important;width:"+pinsize+"px !important;max-width:"+pinsize+"px !important;max-height:"+pinsize*2+"px !important; transform: translateY(50%);";
					pin_args.glyph = glyphImg;
					pin_args.background = "transparent";
					pin_args.borderColor = "transparent";
					pin_args.glyphColor = "transparent";

					let glyphSvgPinElement = new PinElement(pin_args);
				
				  marker_args = {
				      position: location,
				      content: glyphSvgPinElement.element,
				      map: map
				  };

				} else {
					 pin_args.background = aoi_config.primary_color;
					pin_args.borderColor = aoi_config.secondary_color;
					pin_args.glyphColor = aoi_config.glyph_color;

					let glyphSvgPinElement = new PinElement(pin_args);
					
					let svgString = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+pinsize+' '+pinsize+'" width="'+pinsize+'" height="'+pinsize+'"><circle cx="'+pinsize/2+'" cy="'+pinsize/2+'" r="'+pinsize/2+'"  transform="translate(0 0)" fill="'+pin_args.background+'" id="circle"/><circle cx="'+pinsize/2+'" cy="'+pinsize/2+'" r="'+pinsize/4+'"  transform="translate(0 0)" fill="'+pin_args.glyphColor+'" id="circle"/></svg>';
					
					const parser = new DOMParser();
				  const pinSvg = parser.parseFromString(svgString, "image/svg+xml").documentElement;

					//			    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -960 960 960" transform="translate(0 8)" fill="#000"><path d="M214-74q-59.12 0-99.56-40.44Q74-154.88 74-214v-532q0-59.13 40.44-99.56Q154.88-886 214-886h532q59.13 0 99.56 40.44Q886-805.13 886-746v532q0 59.12-40.44 99.56Q805.13-74 746-74H214Z"/></svg>
				  marker_args = {
				      position: location,
				      content: pinSvg,
				      map: map
				  };

				}
		
			  


			  //var marker = new google.maps.Marker(marker_args);
			 	var marker = new google.maps.marker.AdvancedMarkerElement(marker_args);

			  marker.addListener("click", (e) => {
			  	let string_content = 	get_formatted_address_card(clinic);				  												
			  	infowindow.setContent(string_content);
			  	if( infowindow ) {
	           infowindow.close();
	        }
			  	infowindow.open({
			      anchor: marker,
			      map,
			    });
			    setTimeout(() => { 
				    focusedMarker = marker;
				  }, 1000);
			  	jQuery(".clinic-result.active-item").removeClass('active-item');
			    jQuery("#"+clinic.ID+"sidebar").addClass('active-item');

			    let checkbox = jQuery("#"+clinic.ID+"sidebar").parent().parent().find('.accordion_radio');
			    if(checkbox.length){
			    	if(!checkbox.attr('checked')) { 
				    	checkbox.attr('checked', true);
				    }
			    }
			    
			    setTimeout(() => { 
				    let offset = jQuery("#"+clinic.ID+"sidebar").offset().top + jQuery('#clinics-result').scrollTop();
				    	offset = offset - 200;
	 					jQuery('#clinics-result').animate({
	        		scrollTop: offset
	    			}, 500);
    			}, 500);

    			/*jQuery("#"+clinic.ID+"sidebar")[0].scrollIntoView({
					    offsetTop: 500
					}); */

					//scrollIntoViewWithOffset("#"+clinic.ID+"sidebar", 500);

			  	map.setZoom(18);
    			map.setCenter(marker.position);

			  });
			 // console.log('clinic', clinic)
			  marker.clinic = clinic;
				markers.push(marker);

	    });
	    map.setOptions({ maxZoom: maxZoom, minZoom: minZoom });


		}
		//let markers_array =  Object.values(markers), markers;
		//console.log('markers_array', markers_array);

		/*const renderer = {
		    render({ count, position }) {
		    		let icon = {
						   url: NeosCluster, // url
						   scaledSize: new google.maps.Size(30, 43), // size
						};
		        return new google.maps.Marker({
		            label: { text: String(count), color: "white", fontSize: "10px" },
		            position,
		            icon: icon,
		            // adjust zIndex to be above other markers
		            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
		        });
		    }
		}*/
		if(aoi_config.cluster) {
			const markerCluster = new MarkerClusterer({ markers, map});
		}

	}

	const camelize = function(str) {
		return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
		  return index === 0 ? word.toLowerCase() : word.toUpperCase();
		}).replace(/\s+/g, '');
	}


	initialize_map().then((successMessage) => {
	  // successMessage is whatever we passed in the resolve(...) function above.
	  // It doesn't have to be a string, but if it is only a succeed message, it probably will be.

	  if(successMessage.state == 'initialized') {
	  	map_info = successMessage;
	  	get_data();
	  }
	});


	


	let offsetCenter = function(latlng, offsetx, offsety) {

	    // latlng is the apparent centre-point
	    // offsetx is the distance you want that point to move to the right, in pixels
	    // offsety is the distance you want that point to move upwards, in pixels
	    // offset can be negative
	    // offsetx and offsety are both optional

	    var scale = Math.pow(2, map.getZoom());

	    var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	    var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

	    var worldCoordinateNewCenter = new google.maps.Point(
	        worldCoordinateCenter.x - pixelOffset.x,
	        worldCoordinateCenter.y + pixelOffset.y
	    );

	    var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	    map.setCenter(newCenter);

	}

	map.addListener("center_changed", draw_sidebar);
	map.addListener("bounds_changed", draw_sidebar);
	
	map.addListener("zoom_changed", (evt) => {
		if(focusedMarker) {
			//infowindow.close();
			focusedMarker = false;
		}
		
	});

	map.addListener("dragstart", (evt) => {
		if(focusedMarker) {
			//infowindow.close();
			focusedMarker = false;
		}
		
	});

	map.addListener("idle", (evt)=>{
		if(focusedMarker) { 
			
			let offset = jQuery('#'+focusedMarker.clinic.ID+'map').outerHeight();
			offsetCenter(new google.maps.LatLng(focusedMarker.clinic.address.lat,focusedMarker.clinic.address.lng), 0, -offset);

			//map.setCenter();
		}
	});

	let search_by_address = (search_value) => {
		let data = {
			search_value: search_value
		}
		jQuery.ajax({
			type : "post",
			dataType : "json",
			url : "/wp-json"+data_url,
			data : data,
			success: (response) => {
				if(response.center) {
					map.setCenter(new google.maps.LatLng(response.center.lat,response.center.lng));
					map.setZoom(8);
				}
				jQuery('#gmap_loading').hide();
			}
		});

	}

	//handle the ui outside of map
	let handle_address = (evt) => {
  	let search_input = jQuery('#start_address');
  	let search_value = search_input.val();
  	search_input.removeClass('error');
		if(search_value.length < 5) {
			search_input.addClass('error');
		} else {
			jQuery('#gmap_loading').css('display', 'flex');
			//get_data(false, get_radius_from_map(), search_value);
			search_by_address(search_value);

		}
		
		/*if(!window.findYourClinicInitialized) {
			//
			//map.addListener("zoom_changed", redraw_markers);
			map.addListener("idle", (evt)=>{
				set_radius_after_initial = get_radius_from_map();
				if(set_radius_after_initial < 50) {
					set_radius_after_initial = 50
				}
				
				disable_get_data = false;
			});
			window.findYourClinicInitialized = true;
			
		}*/

  	evt.preventDefault();
  	evt.stopPropagation();
  	return;
  };

  jQuery('#search_address').on('focus', () => { jQuery('#start_address').removeClass('error'); });
	jQuery('#find-a-clinic-form').on('submit', handle_address);
	jQuery('#reset_map').on('click', () => {
		location.reload(true);
	});



});